import { render, staticRenderFns } from "./upFileModel.vue?vue&type=template&id=61453569&scoped=true&"
import script from "./upFileModel.vue?vue&type=script&lang=js&"
export * from "./upFileModel.vue?vue&type=script&lang=js&"
import style0 from "./upFileModel.vue?vue&type=style&index=0&id=61453569&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61453569",
  null
  
)

export default component.exports